import axios from 'axios';
import Vue from 'vue';
import { Unauthorized, Forbidden } from '../exceptions';

const instance = axios.create({
  baseURL: Vue.env.VUE_APP_APIPATH_Authorization
});

instance.interceptors.response.use((response) => response.data, (error) => {
  const resp = error.response;
  switch (resp.status) {
    case 401:
      throw new Unauthorized();
    case 403:
      throw new Forbidden();
    default:
      return Promise.reject(resp.data);
  }
});

/**
 * 取得公司清單
 * @param {string} accessToken access token
 * @returns {promise} promise object, result: api result
 */
export async function GetCompaniesAsync(accessToken) {
  const url = '/api/v1/Companies';

  return instance.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
}

/**
 * 取得功能清單
 * @param {string} accessToken access token
 * @param {string} companyId companyId
 * @returns {promise} promise object, result: api result
 */
export async function GetFeaturesAsync(accessToken, companyId) {
  const url = '/api/v1/Features';

  return instance.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Company': companyId
    }
  });
}

/**
 * 取得功能操作權限清單
 * @param {string} accessToken access token
 * @param {string} companyId companyId
 * @param {string} feature feature
 * @returns {promise} promise object, result: api result
 */
export async function GetPermissionsAsync(accessToken, companyId, feature) {
  const url = '/api/v1/permissions';

  return instance.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Company': companyId,
      'X-Feature': feature
    }
  });
}

/**
 * 驗證
 * @param {string} accessToken access token
 * @param {string} companyId companyId
 * @param {string} feature feature
 * @returns {promise} promise object, result: api result
 */
export async function VerifyAsync(accessToken, companyId, feature) {
  const url = '/api/v1/verify';

  return instance.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Company': companyId,
      'X-Feature': feature
    }
  });
}
